import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";
import { IPracticeSetItem } from "../../types";
import { usePear } from "../pear";

export interface IFetchPracticeSetItemResponse {
  practice_set_item: IPracticeSetItem;
}

export interface IUseFetchPracticeSetItemArgs {
  id: string;
  isQueryEnabled: boolean;
}

export default function useFetchPracticeSetItem(
  args: IUseFetchPracticeSetItemArgs
): UseQueryResult<IFetchPracticeSetItemResponse> {
  const { id, isQueryEnabled } = args;

  const pear = usePear();
  const axios = useAxios();

  const query = useQuery<IFetchPracticeSetItemResponse>(
    ["practiceSetItems", { id }],
    async (): Promise<IFetchPracticeSetItemResponse> => {
      const response = await axios
        .get(`/v1/practice-sets/items/${id}`)
        .then((r) => r.data as { practice_set_item: IPracticeSetItem });

      await pear.populatePracticeSetItemStandards(response.practice_set_item);

      return {
        practice_set_item: response.practice_set_item,
      };
    },
    {
      enabled: isQueryEnabled,
    }
  );

  return query;
}
